import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class Storefront {
  id: number;
  name: string;
  address?: string;
  url?: string;

  constructor(id: number, name: string, address?: string, url?: string) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.url = url;
  }

  static fromJson(json: Record<string, any>): Storefront {
    return plainToInstance(Storefront, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
